import React from 'react';

interface SmsConsentCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const SmsConsentCheckbox: React.FC<SmsConsentCheckboxProps> = ({
  id,
  checked,
  onChange,
  className = '',
}) => {
  return (
    <fieldset className={`rounded-lg border-2 border-gray-200 bg-gray-50 p-4 ${className}`}>
      <legend className="px-1 text-xs font-semibold uppercase tracking-wide text-gray-600">
        Optional SMS Opt-In
      </legend>
      <div className="flex items-start gap-3">
        <input
          id={id}
          type="checkbox"
          name="smsConsent"
          checked={checked}
          onChange={onChange}
          value="yes"
          className="mt-0.5 h-5 w-5 flex-shrink-0 cursor-pointer accent-brand-teal"
        />
      <label htmlFor={id} className="text-xs text-gray-500 leading-relaxed cursor-pointer">
        By checking this box, I consent to receive customer care SMS messages from Chomp Pet Dental at the phone number provided. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out. For assistance, text HELP or visit our website at{' '}
        <a href="https://www.chomppetdental.com" className="text-brand-teal hover:underline">
          www.chomppetdental.com
        </a>
        . Consent is not a condition of purchase. View our Privacy Policy at{' '}
        <a href="https://chomp.vet/privacy-policy" className="text-brand-teal hover:underline">
          https://chomp.vet/privacy-policy
        </a>{' '}
        and Terms &amp; Conditions at{' '}
        <a href="https://chomp.vet/terms-and-conditions" className="text-brand-teal hover:underline">
          https://chomp.vet/terms-and-conditions
        </a>
        .
      </label>
      </div>
    </fieldset>
  );
};

export default SmsConsentCheckbox;
